/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "company/tender/models.proto" (package "rd.company.tender", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Money } from "../../proto/money/models_pb";
import { Decimal } from "../../proto/decimal/models_pb";
import { User } from "../../user/models_pb";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { UUID } from "../../proto/uuid/models_pb";
/**
 * Method represents a form of exchanging monetary value between a customer and a company.
 *
 * @generated from protobuf message rd.company.tender.Method
 */
export interface Method {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 3
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User updated_by = 5
     */
    updatedBy?: User;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 6
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.company.tender.Method.Type type = 7
     */
    type: Method_Type;
    /**
     * @generated from protobuf field: bool is_active = 8
     */
    isActive: boolean;
    /**
     * @generated from protobuf field: string name = 9
     */
    name: string;
    /**
     * @generated from protobuf field: int32 position = 10
     */
    position: number;
    /**
     * @generated from protobuf field: repeated rd.company.tender.Method.Usage usages = 11
     */
    usages: Method_Usage[];
    /**
     * @generated from protobuf field: rd.company.tender.Method.Adjustment internal_adjustment = 12
     */
    internalAdjustment?: Method_Adjustment;
    /**
     * @generated from protobuf field: rd.company.tender.Method.Adjustment external_adjustment = 13
     */
    externalAdjustment?: Method_Adjustment;
    /**
     * @generated from protobuf field: rd.company.tender.Method.CustomForm custom_form = 14
     */
    customForm?: Method_CustomForm;
}
/**
 * @generated from protobuf message rd.company.tender.Method.Adjustment
 */
export interface Method_Adjustment {
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal rate = 1
     */
    rate?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.Money fee = 2
     */
    fee?: Money;
    /**
     * @generated from protobuf field: bool is_taxable = 3
     */
    isTaxable: boolean;
}
/**
 * @generated from protobuf message rd.company.tender.Method.CustomForm
 */
export interface Method_CustomForm {
    /**
     * @generated from protobuf field: string label = 1
     */
    label: string;
    /**
     * @generated from protobuf field: bool is_required = 2
     */
    isRequired: boolean;
}
/**
 * @generated from protobuf enum rd.company.tender.Method.Type
 */
export enum Method_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_CHARGE_ACCOUNT = 1;
     */
    CHARGE_ACCOUNT = 1,
    /**
     * @generated from protobuf enum value: TYPE_CARD = 3;
     */
    CARD = 3,
    /**
     * @generated from protobuf enum value: TYPE_CASH = 4;
     */
    CASH = 4,
    /**
     * @generated from protobuf enum value: TYPE_CHECK = 5;
     */
    CHECK = 5,
    /**
     * @generated from protobuf enum value: TYPE_WRITE_OFF = 6;
     */
    WRITE_OFF = 6,
    /**
     * @generated from protobuf enum value: TYPE_CUSTOM = 7;
     */
    CUSTOM = 7,
    /**
     * @generated from protobuf enum value: TYPE_ACH = 8;
     */
    ACH = 8,
    /**
     * @generated from protobuf enum value: TYPE_GIFT_CARD = 9;
     */
    GIFT_CARD = 9
}
/**
 * @generated from protobuf enum rd.company.tender.Method.Usage
 */
export enum Method_Usage {
    /**
     * @generated from protobuf enum value: USAGE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: USAGE_SALE_PAYMENT = 1;
     */
    SALE_PAYMENT = 1,
    /**
     * @generated from protobuf enum value: USAGE_RETURN_REFUND = 2;
     */
    RETURN_REFUND = 2,
    /**
     * @generated from protobuf enum value: USAGE_BILL_PAYMENT = 3;
     */
    BILL_PAYMENT = 3,
    /**
     * @generated from protobuf enum value: USAGE_BILL_REFUND = 4;
     */
    BILL_REFUND = 4,
    /**
     * @generated from protobuf enum value: USAGE_DEPOSIT_PAYMENT = 5;
     */
    DEPOSIT_PAYMENT = 5,
    /**
     * @generated from protobuf enum value: USAGE_DEPOSIT_REFUND = 6;
     */
    DEPOSIT_REFUND = 6
}
// @generated message type with reflection information, may provide speed optimized methods
class Method$Type extends MessageType<Method> {
    constructor() {
        super("rd.company.tender.Method", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "created_by", kind: "message", T: () => User },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_by", kind: "message", T: () => User },
            { no: 6, name: "company_id", kind: "message", T: () => UUID },
            { no: 7, name: "type", kind: "enum", T: () => ["rd.company.tender.Method.Type", Method_Type, "TYPE_"] },
            { no: 8, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "usages", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.company.tender.Method.Usage", Method_Usage, "USAGE_"] },
            { no: 12, name: "internal_adjustment", kind: "message", T: () => Method_Adjustment },
            { no: 13, name: "external_adjustment", kind: "message", T: () => Method_Adjustment },
            { no: 14, name: "custom_form", kind: "message", T: () => Method_CustomForm }
        ]);
    }
    create(value?: PartialMessage<Method>): Method {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.isActive = false;
        message.name = "";
        message.position = 0;
        message.usages = [];
        if (value !== undefined)
            reflectionMergePartial<Method>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Method): Method {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 3:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.user.User updated_by */ 5:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 6:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.company.tender.Method.Type type */ 7:
                    message.type = reader.int32();
                    break;
                case /* bool is_active */ 8:
                    message.isActive = reader.bool();
                    break;
                case /* string name */ 9:
                    message.name = reader.string();
                    break;
                case /* int32 position */ 10:
                    message.position = reader.int32();
                    break;
                case /* repeated rd.company.tender.Method.Usage usages */ 11:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.usages.push(reader.int32());
                    else
                        message.usages.push(reader.int32());
                    break;
                case /* rd.company.tender.Method.Adjustment internal_adjustment */ 12:
                    message.internalAdjustment = Method_Adjustment.internalBinaryRead(reader, reader.uint32(), options, message.internalAdjustment);
                    break;
                case /* rd.company.tender.Method.Adjustment external_adjustment */ 13:
                    message.externalAdjustment = Method_Adjustment.internalBinaryRead(reader, reader.uint32(), options, message.externalAdjustment);
                    break;
                case /* rd.company.tender.Method.CustomForm custom_form */ 14:
                    message.customForm = Method_CustomForm.internalBinaryRead(reader, reader.uint32(), options, message.customForm);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Method, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 3; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 5; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 6; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.tender.Method.Type type = 7; */
        if (message.type !== 0)
            writer.tag(7, WireType.Varint).int32(message.type);
        /* bool is_active = 8; */
        if (message.isActive !== false)
            writer.tag(8, WireType.Varint).bool(message.isActive);
        /* string name = 9; */
        if (message.name !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.name);
        /* int32 position = 10; */
        if (message.position !== 0)
            writer.tag(10, WireType.Varint).int32(message.position);
        /* repeated rd.company.tender.Method.Usage usages = 11; */
        if (message.usages.length) {
            writer.tag(11, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.usages.length; i++)
                writer.int32(message.usages[i]);
            writer.join();
        }
        /* rd.company.tender.Method.Adjustment internal_adjustment = 12; */
        if (message.internalAdjustment)
            Method_Adjustment.internalBinaryWrite(message.internalAdjustment, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.tender.Method.Adjustment external_adjustment = 13; */
        if (message.externalAdjustment)
            Method_Adjustment.internalBinaryWrite(message.externalAdjustment, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.tender.Method.CustomForm custom_form = 14; */
        if (message.customForm)
            Method_CustomForm.internalBinaryWrite(message.customForm, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.tender.Method
 */
export const Method = new Method$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Method_Adjustment$Type extends MessageType<Method_Adjustment> {
    constructor() {
        super("rd.company.tender.Method.Adjustment", [
            { no: 1, name: "rate", kind: "message", T: () => Decimal },
            { no: 2, name: "fee", kind: "message", T: () => Money },
            { no: 3, name: "is_taxable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Method_Adjustment>): Method_Adjustment {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isTaxable = false;
        if (value !== undefined)
            reflectionMergePartial<Method_Adjustment>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Method_Adjustment): Method_Adjustment {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.decimal.Decimal rate */ 1:
                    message.rate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.rate);
                    break;
                case /* rd.proto.money.Money fee */ 2:
                    message.fee = Money.internalBinaryRead(reader, reader.uint32(), options, message.fee);
                    break;
                case /* bool is_taxable */ 3:
                    message.isTaxable = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Method_Adjustment, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.decimal.Decimal rate = 1; */
        if (message.rate)
            Decimal.internalBinaryWrite(message.rate, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money fee = 2; */
        if (message.fee)
            Money.internalBinaryWrite(message.fee, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool is_taxable = 3; */
        if (message.isTaxable !== false)
            writer.tag(3, WireType.Varint).bool(message.isTaxable);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.tender.Method.Adjustment
 */
export const Method_Adjustment = new Method_Adjustment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Method_CustomForm$Type extends MessageType<Method_CustomForm> {
    constructor() {
        super("rd.company.tender.Method.CustomForm", [
            { no: 1, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "is_required", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Method_CustomForm>): Method_CustomForm {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.label = "";
        message.isRequired = false;
        if (value !== undefined)
            reflectionMergePartial<Method_CustomForm>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Method_CustomForm): Method_CustomForm {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string label */ 1:
                    message.label = reader.string();
                    break;
                case /* bool is_required */ 2:
                    message.isRequired = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Method_CustomForm, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string label = 1; */
        if (message.label !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.label);
        /* bool is_required = 2; */
        if (message.isRequired !== false)
            writer.tag(2, WireType.Varint).bool(message.isRequired);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.tender.Method.CustomForm
 */
export const Method_CustomForm = new Method_CustomForm$Type();
